import { all, put, takeEvery, call } from 'redux-saga/effects'
import { store as reduxStore } from 'index'
import i18n from 'i18n'

import getMenuData from 'services/menu'
import getRoutes from 'services/router'
import actions from './actions'
import { MenuAction, MenuDataResponse, RouteItem } from './types'

const menuActionListener: Array<(key: string) => void> = []

const info = {
  initialized: false,
}

export function* GET_DATA(action: MenuAction) {
  if (action.type !== 'menu/GET_DATA' && action.type !== 'menu/RELOAD') return

  const { menuData, configData }: MenuDataResponse = yield call(getMenuData)
  const routerData: RouteItem[] = yield call(getRoutes)

  if (info.initialized === false) {
    if (action.payload == null || action.payload.loading !== true) {
      info.initialized = true
    }
  }

  yield put({
    type: 'menu/SET_STATE',
    payload: {
      initialized: info.initialized,
      menuData,
      routerData,
      configData,
    },
  })
}

export function* ADD_LISTENER(action: MenuAction) {
  if (action.type !== 'menu/ADD_LISTENER') return

  const { listener } = action.payload
  if (menuActionListener.indexOf(listener) < 0) {
    menuActionListener.push(listener)
  }
}

export function* REMOVE_LISTENER(action: MenuAction) {
  if (action.type !== 'menu/REMOVE_LISTENER') return

  const { listener } = action.payload
  const pos = menuActionListener.indexOf(listener)
  if (pos >= 0) {
    menuActionListener.splice(pos, 1)
  }
}

export function* NOTIFY_LISTENER(action: MenuAction) {
  if (action.type !== 'menu/NOTIFY_LISTENER') return

  const { key } = action.payload
  menuActionListener.forEach((listener) => {
    listener(key)
  })
}

function* INIT_DATA() {
  if (i18n.isInitialized === true) {
    yield call(GET_DATA, { type: 'menu/RELOAD', payload: { loading: true } })
  } else {
    i18n.on('initialized', () => {
      reduxStore.dispatch({
        type: actions.RELOAD,
        payload: { loading: true },
      })
    })
  }
}

export default function* rootSaga() {
  if (window.parent === window) {
    yield all([
      takeEvery(actions.RELOAD, GET_DATA),
      takeEvery(actions.ADD_LISTENER, ADD_LISTENER),
      takeEvery(actions.REMOVE_LISTENER, REMOVE_LISTENER),
      takeEvery(actions.NOTIFY_LISTENER, NOTIFY_LISTENER),
      call(INIT_DATA), // run once on app load to fetch menu data
    ])
  }
}
